/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  BillingV1SubscriptionChargeLinesListParams,
  BillingV1SubscriptionChargeLinesListPathParameters,
  BillingV1SubscriptionChargeLinesRetrievePathParameters,
  CursorPaginatedSubscriptionChargeLineResponseV1,
  SubscriptionChargeLineResponseV1
} from '../types';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class BillingSubscriptionChargeLineService {
  private readonly http = inject(HttpClient);
/**
 * Sub-resource list — returns every SubscriptionChargeLine belonging to the parent SubscriptionCharge, cursor-paginated. Ordered by insertion (id ASC) — cursor pagination cannot order by a related field. Admin-only. NOTE: SubscriptionChargeLine rows are INFORMATIONAL — they do NOT sum into the parent total (the total comes from the UF snapshot). See `billing-model.md`.
 * @summary List all lines of a SubscriptionCharge
 */
 billingV1SubscriptionChargeLinesList<TData = CursorPaginatedSubscriptionChargeLineResponseV1>(pathParams: BillingV1SubscriptionChargeLinesListPathParameters,
    params?: BillingV1SubscriptionChargeLinesListParams, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1SubscriptionChargeLinesList<TData = CursorPaginatedSubscriptionChargeLineResponseV1>(pathParams: BillingV1SubscriptionChargeLinesListPathParameters,
    params?: BillingV1SubscriptionChargeLinesListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1SubscriptionChargeLinesList<TData = CursorPaginatedSubscriptionChargeLineResponseV1>(pathParams: BillingV1SubscriptionChargeLinesListPathParameters,
    params?: BillingV1SubscriptionChargeLinesListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1SubscriptionChargeLinesList<TData = CursorPaginatedSubscriptionChargeLineResponseV1>(
    { identity }: BillingV1SubscriptionChargeLinesListPathParameters,
    params?: BillingV1SubscriptionChargeLinesListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/subscription_charges/${identity}/lines/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/subscription_charges/${identity}/lines/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/v1/billing/subscription_charges/${identity}/lines/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Sub-resource detail — returns one SubscriptionChargeLine scoped to its parent SubscriptionCharge. Returns 404 if the line does not belong to this charge. Admin-only.
 * @summary Get one line of a SubscriptionCharge
 */
 billingV1SubscriptionChargeLinesRetrieve<TData = SubscriptionChargeLineResponseV1>(pathParams: BillingV1SubscriptionChargeLinesRetrievePathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1SubscriptionChargeLinesRetrieve<TData = SubscriptionChargeLineResponseV1>(pathParams: BillingV1SubscriptionChargeLinesRetrievePathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1SubscriptionChargeLinesRetrieve<TData = SubscriptionChargeLineResponseV1>(pathParams: BillingV1SubscriptionChargeLinesRetrievePathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1SubscriptionChargeLinesRetrieve<TData = SubscriptionChargeLineResponseV1>(
    { identity, lineIdentity }: BillingV1SubscriptionChargeLinesRetrievePathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/subscription_charges/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/subscription_charges/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v1/billing/subscription_charges/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

export type BillingV1SubscriptionChargeLinesListClientResult = NonNullable<CursorPaginatedSubscriptionChargeLineResponseV1>
export type BillingV1SubscriptionChargeLinesRetrieveClientResult = NonNullable<SubscriptionChargeLineResponseV1>
